export const CALENDAR_REVIEW_PROMPT = 'Review my current Calendar schedule without changing any task blocks, deadlines or meetings. Check what is scheduled now and explain what needs attention before we schedule anything else.';
export const CALENDAR_UNCERTAIN_NOTICE = 'The request stopped or the connection was lost. It may have changed the schedule. Review the current schedule before scheduling again.';

export type CalendarRequestOutcome = {
  controller: AbortController;
  panelKey: string;
  contextKey: string;
  dispatched: boolean;
  settled: boolean;
  committed?: boolean;
  handled: boolean;
};

export function isUncertainCalendarRequest(request: CalendarRequestOutcome | null): request is CalendarRequestOutcome {
  return Boolean(request?.dispatched && !request.settled && !request.handled);
}
